import React from "react";
import PropTypes from "prop-types";

import { UIDocumentRow, UIModal } from "../../../../ui";
import "./EventPayrollViewProofModal.scss";
import { FileText } from "lucide-react";

const EventPayrollViewProofModal = ({
  open,
  fileName,
  href,
  fileSizeLabel,
  labels,
  shared,
  onClose,
}) => {
  const subtitle = fileSizeLabel
    ? (labels.readyMeta || "").replace("{size}", fileSizeLabel)
    : labels.readyToUpload;

  return (
    <UIModal
      open={open}
      type="info"
      title={labels.title}
      cancelLabel={shared.cancel}
      onClose={onClose}
      onCancel={onClose}
      aria-labelledby="event-payroll-view-proof-modal-title"
    >
      <UIDocumentRow
        className="event-payroll-view-proof-document"
        title={fileName}
        subtitle={subtitle}
        href={href}
        downloadLabel={shared.download}
        icon={<FileText  strokeWidth={1.75} />}
      />
    </UIModal>
  );
};

EventPayrollViewProofModal.propTypes = {
  open: PropTypes.bool.isRequired,
  fileName: PropTypes.string,
  href: PropTypes.string,
  fileSizeLabel: PropTypes.string,
  labels: PropTypes.object.isRequired,
  shared: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

EventPayrollViewProofModal.defaultProps = {
  fileName: "",
  href: "",
  fileSizeLabel: "",
};

export default EventPayrollViewProofModal;
